export const HEADER_HOME = 'HEADER_HOME';
export const HEADER_TVGUIDE = 'HEADER_TVGUIDE';
export const HEADER_SETTINGS = 'HEADER_SETTINGS';
export const HEADER_SEARCH = 'HEADER_SEARCH';
export const HEADER_EXPLORE = 'HEADER_EXPLORE';
export const HEADER_DEVELOPER = 'HEADER_DEVELOPER';

export const HEADER_MOVIES = 'HEADER_MOVIES';
export const HEADER_SERIES = 'HEADER_SERIES';
export const HEADER_PROGRAMS = 'HEADER_PROGRAMS';
export const HEADER_CHILDREN = 'HEADER_CHILDREN';

export const HEADER_FOCUS_KEYS: string[] = [
  HEADER_HOME,
  HEADER_TVGUIDE,
  HEADER_EXPLORE,
  HEADER_SETTINGS,
  HEADER_SEARCH
];

export const UniverseIdToExploreFocusKey = (universId: number) => {
  let focusKey = '';
  switch (universId) {
    case 2:
      focusKey = HEADER_MOVIES;
      break;
    case 5:
      focusKey = HEADER_SERIES;
      break;
    case 4:
      focusKey = HEADER_CHILDREN;
      break;
    case 3:
      focusKey = HEADER_PROGRAMS;
      break;
    default:
      focusKey = 'HEADER_' + universId;
  }

  return focusKey;
};

export const isTvGuideDateReset = (focusKey: string, href: string, isToday: boolean): boolean =>
  focusKey === HEADER_TVGUIDE && window.location.pathname === href && !isToday;
